// The model report of the current model (`currentClientObject`), as `parsedModelReport`: read inline
// from older models, fetched from Storage for the rest and fetched again whenever the report
// changes. The same loading the Plan Calculator and Plan Optimizer views do.

import { loadModelReportFromClient } from '@/utils/modelReport.js'

export const currentModelReport = {
  data () {
    return {
      fetchedModelReport: null,
      fetchedModelReportFor: null
    }
  },
  computed: {
    parsedModelReport () {
      if (!this.currentClientObject) return null
      if (this.currentClientObject.model_report_storage) {
        return this.fetchedModelReport
      }
      const modelReport = this.currentClientObject.model_report
      if (!modelReport) return null
      if (typeof modelReport === 'string') {
        try {
          return JSON.parse(modelReport)
        } catch (e) {
          console.error('Failed to parse model_report:', e)
          return null
        }
      }
      return modelReport
    },
    modelReportFetchKey () {
      if (!this.currentClientObject || !this.currentClientObject.model_report_storage) return null
      const ts = this.currentClientObject.model_report_updated_at
      let tsKey = ''
      if (ts) {
        if (typeof ts.toMillis === 'function') tsKey = String(ts.toMillis())
        else if (ts.seconds !== undefined) tsKey = ts.seconds + '.' + (ts.nanoseconds || 0)
        else tsKey = String(ts)
      }
      return this.currentClientObject.model_report_storage + '@' + tsKey
    }
  },
  watch: {
    modelReportFetchKey: {
      immediate: true,
      handler (newKey) {
        if (!newKey) {
          this.fetchedModelReport = null
          this.fetchedModelReportFor = null
          return
        }
        if (newKey === this.fetchedModelReportFor) return
        const target = newKey
        loadModelReportFromClient(this.currentClientObject)
          .then(report => {
            if (this.modelReportFetchKey === target) {
              this.fetchedModelReport = report
              this.fetchedModelReportFor = target
            }
          })
          .catch(err => {
            console.error('Failed to load model_report from Storage:', err)
            if (this.modelReportFetchKey === target) {
              this.fetchedModelReport = null
              this.fetchedModelReportFor = target
            }
          })
      }
    }
  }
}
